(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('dhl-portal-');
        $sessionStorageProvider.setKeyPrefix('dhl-portal-');
    }
})();
